import calc from '../calc/modules/calcReducer';

export default  {
  calc
};